import { render, staticRenderFns } from "./SupportingDocUpload.vue?vue&type=template&id=724d7665&scoped=true&"
import script from "./SupportingDocUpload.vue?vue&type=script&lang=js&"
export * from "./SupportingDocUpload.vue?vue&type=script&lang=js&"
import style0 from "./SupportingDocUpload.vue?vue&type=style&index=0&id=724d7665&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724d7665",
  null
  
)

export default component.exports